import React from "react";
import { Link } from "@mui/material";
import "./news.css";

const News = ({ news }) => {
  return (
    <div className="news_list">
      <ul>
        {news.map((n) => (
          <li key={n.title}>
            <div>
              <img src={n?.image} alt="" />
            </div>
            <Link href={n?.url} underline="hover" target={"_blank"}>
              {n?.title}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default News;
